import * as Sentry from '@sentry/react'
import SHA256 from 'crypto-js/sha256'

// Fixed pepper. Do not change once deployed: changing it makes Sentry treat the
// same client as a new user and resets per-user impact counts.
const SENTRY_USER_PEPPER = 'portal-sentry-thprt6294-4d8f2a9c1e7b6035'

export const setSentryUser = (userId: number | string | null | undefined): void => {
    if (userId === null || userId === undefined || userId === '') {
        Sentry.setUser(null)
        return
    }
    Sentry.setUser({ id: SHA256(`${userId}${SENTRY_USER_PEPPER}`).toString() })
}

export const clearSentryUser = (): void => setSentryUser(null)
